import React from 'react';
import { useTranslation } from 'react-i18next';
import * as Styled from './DonationFrequencySelect.styled';
import { RecurringEndDatePicker } from './RecurringEndDatePicker';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * The hide-able Donation Frequency Select and hide-able End Date Picker
 */
export const DonationFrequencySelect = ({
  value,
  options,
  dispatch,
  blockId,
  hideRecurringEndDate,
  shouldShowErrorState,
  recurringEndDate,
  hideDonationFrequencySelect
}) => {
  const {
    t
  } = useTranslation(['blocks.impact', 'blocks.common']);

  // Dynamically generate localized labels for options
  const frequencyLabels = options.reduce((acc, frequency) => {
    acc[frequency] = t(`blocks.common:Frequency.${frequency}`, frequency);
    return acc;
  }, {});
  return /*#__PURE__*/_jsxs(Styled.DonationFrequencyFieldset, {
    "aria-label": hideRecurringEndDate ? t('DonationFrequencySelect.fieldset.ariaLabelNoEndDate', 'Recurring donation frequency') : t('DonationFrequencySelect.fieldset.ariaLabelWithEndDate', 'Recurring donation frequency and optional end date'),
    children: [!hideDonationFrequencySelect && /*#__PURE__*/_jsx(Styled.DonationFrequencySelect, {
      "data-id": "cp-impact-frequency",
      label: t('DonationFrequencySelect.select.label', 'Donation frequency'),
      value: value,
      options: options,
      optionDisplayStrings: frequencyLabels,
      onChange: e => {
        e.preventDefault();
        dispatch({
          type: 'SELECT_DONATION_FREQUENCY',
          frequency: e.target.value
        });
      },
      name: "donation-frequency"
    }), !hideRecurringEndDate && /*#__PURE__*/_jsx(RecurringEndDatePicker, {
      onChange: recurrentEndDate => {
        dispatch({
          type: 'SELECT_RECURRING_END_DATE',
          recurrentEndDate
        });
      },
      onBlur: () => dispatch({
        type: 'TOUCH_ERRORABLE_INPUT',
        input: 'recurringEndDateSelect'
      }),
      shouldShowErrorState: shouldShowErrorState,
      recurringEndDate: recurringEndDate,
      "aria-invalid": shouldShowErrorState,
      "aria-errormessage": `${blockId}-error-message`
    })]
  });
};